class ShareEntity {
	static fromArray(data, list) {
		let inst = new ShareEntity(
			data.shift(),
			data.shift(),
			list
		);
		return inst;
	}

	constructor(id, name, list) {
		this._id = id;
		this._name = name;
		this._list = list;
		
		this._viewPrev = 0;
		this._editPrev = 0;
		this._sharePrev = 0;

		this._viewChk = chk('alt-chk');
		this._editChk = chk('alt-chk');
		this._shareChk = chk('alt-chk');

		onEv(this._viewChk, 'click', this.viewClicked.bind(this));
		onEv(this._shareChk, 'click', this.otherClicked.bind(this));
		onEv(this._editChk, 'click', this.otherClicked.bind(this));
	}

	get id() {return this._id;}
	get changed() {
		return (this._viewPrev == 0 && this._viewChk.checked) ||
				(this._viewPrev == 1 && !this._viewChk.checked) ||
				(this._viewPrev == -1 && !this._viewChk.indeterminate) ||
				(this._editPrev == 0 && this._editChk.checked) ||
				(this._editPrev == 1 && !this._editChk.checked) ||
				(this._editPrev == -1 && !this._editChk.indeterminate) ||
				(this._sharePrev == 0 && this._shareChk.checked) ||
				(this._sharePrev == 1 && !this._shareChk.checked) ||
				(this._sharePrev == -1 && !this._shareChk.indeterminate) ;
	}
	get access() {
		if (this._shareChk.checked) return 2;
		if (this._viewChk.checked) return 1;
		return 0;

		// code below for bitwise access database changes
		let access = 0;
		if (this._viewChk.checked) access += 1;
		if (this._editChk.checked) access += 2;
		if (this._shareChk.checked) access += 4;
		return access;
	}
	get edit() {
		return !!this._editChk.checked ? 1 : 0;
	}

	get elem() {
		let options = [label('share-option', [this._viewChk, span('i-rg chk-box')])];

		if (this._list.editOption && !isCommunity) {
			options.push(label('share-option', [this._editChk, span('i-rg chk-box')]));
		}

		if (this._list.shareOption && !isCommunity) {
			options.push(label('share-option', [this._shareChk, span('i-rg chk-box')]));
		}

		this._elem = div('list-row align-items-center', [
			div('col-auto ms-5', span(null, this._name)),
			div('col-auto ms-auto me-4', options)
		]);
		return this._elem;
	}
		
	get map() {
		return [this._id, this.access, this.edit];
	}

	clear() {
		this._viewChk.checked = false;
		this._editChk.checked = false;
		this._shareChk.checked = false;
		this.update();
	}

	init(total, view, edit, share) {
		if (parseInt(view) === 0) {
			this._viewPrev = 0;
			this._viewChk.checked = false;
			this._viewChk.indeterminate = false;
		}
		else if(parseInt(view) === total) {
			this._viewPrev = 1;
			this._viewChk.checked = true;
			this._viewChk.indeterminate = false;
		}
		else {
			this._viewPrev = -1;
			this._viewChk.checked = false;
			this._viewChk.indeterminate = true;
		}

		if (parseInt(edit) === 0) {
			this._editPrev = 0;
			this._editChk.checked = false;
			this._editChk.indeterminate = false;
		}
		else if(parseInt(edit) === total) {
			this._editPrev = 1;
			this._editChk.checked = true;
			this._editChk.indeterminate = false;
		}
		else {
			this._editPrev = -1;
			this._editChk.checked = false;
			this._editChk.indeterminate = true;
		}
		if (parseInt(share) === 0) {
			this._sharePrev = 0;
			this._shareChk.checked = false;
			this._shareChk.indeterminate = false;
		}
		else if(parseInt(share) === total) {
			this._sharePrev = 1;
			this._shareChk.checked = true;
			this._shareChk.indeterminate = false;
		}
		else {
			this._sharePrev = -1;
			this._shareChk.checked = false;
			this._shareChk.indeterminate = true;
		}
	}

	viewClicked() {
		if (!this._viewChk.checked) {
			this._editChk.checked = false;
			this._shareChk.checked = false;
		}
		this.update();
	}

	otherClicked() {
		if (this._editChk.checked || this._shareChk.checked) {
			this._viewChk.checked = true;
		}
		this.update();
	}

	update() {
		if (isCommunity) {
			ajg('sharing/'+ this._list._type, [
				'selectionIds=' + encodeURI(this._list._selectionIds.join(',')),
				'changes=' + JSON.stringify([this.map])
			], null, (reply) => {
				showError(reply);
				// this.changed = false;
				this._view = (this._viewChk.checked ? 1 : 0);
			})
		}
	}
}